<div id="customer"></div>